import { Grid, Typography } from '@mui/material';
import { themeObject, validationsMessages } from 'lib';
import * as yup from 'yup';

export interface UserWalletFormData {
    fullName: string;
    email: string;
}

export const UserWalletSchema = yup.object({
    fullName: yup.string().required(validationsMessages.required),
    email: yup
        .string()
        .required(validationsMessages.required)
        .test('no-spaces', 'Enter a valid email address.', (value): any => {
            return value && !/\s/.test(value);
        }),
});

export const userWalletDefaults = {
    fullName: '',
    email: '',
};

export interface UpdateUserWalletFormData {
    principal: string;
    fullName: string;
    email: string;
}

export const UpdateUserWalletSchema = yup.object({
    principal: yup.string().optional(),
    fullName: yup.string().required(validationsMessages.required),
    email: yup
        .string()
        .required(validationsMessages.required)
        .test('no-spaces', 'Enter a valid email address.', (value): any => {
            return value && !/\s/.test(value);
        }),
});

export const updateUserWalletDefaults = {
    principal: '',
    fullName: '',
    email: '',
};

export const updateUserWalletStyles = {
    labelAndValueContainer: {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        gap: '4px',
        mt: 2,
    },
    labelStyles: {
        ...themeObject.typography.inputLabel,
        lineHeight: '21.17px',
        letterSpacing: '0.15px',
        color: themeObject.palette.grayScale[800],
    },
    valueStyles: {
        ...themeObject.typography.Components.inputText,
        lineHeight: '24px',
        color: themeObject.palette.grayScale[800],
    },
};

export const LabelAndValueComponent = ({
    label,
    value,
}: {
    label: string;
    value: string;
}): React.JSX.Element => {
    return (
        <Grid sx={updateUserWalletStyles.labelAndValueContainer}>
            <Grid>
                <Typography sx={updateUserWalletStyles.labelStyles}>
                    {label}
                </Typography>
            </Grid>
            <Grid>
                <Typography sx={updateUserWalletStyles.valueStyles}>
                    {value}
                </Typography>
            </Grid>
        </Grid>
    );
};
